var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectricPoolCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.5V4C18 2.895 18.895 2 20 2H22",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 13.5V4C5 2.895 5.895 2 7 2H9",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6H18",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10H18",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 17L3.25 17.6757C4.05 18.1081 4.95 18.1081 5.75 17.6757C6.55 17.2432 7.45 17.2432 8.25 17.6757C9.05 18.1081 9.95 18.1081 10.75 17.6757C11.55 17.2432 12.45 17.2432 13.25 17.6757C14.05 18.1081 14.95 18.1081 15.75 17.6757C16.55 17.2432 17.45 17.2432 18.25 17.6757C19.05 18.1081 19.95 18.1081 20.75 17.6757L22 17",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 20L3.25 20.6757C4.05 21.1081 4.95 21.1081 5.75 20.6757C6.55 20.2432 7.45 20.2432 8.25 20.6757C9.05 21.1081 9.95 21.1081 10.75 20.6757C11.55 20.2432 12.45 20.2432 13.25 20.6757C14.05 21.1081 14.95 21.1081 15.75 20.6757C16.55 20.2432 17.45 20.2432 18.25 20.6757C19.05 21.1081 19.95 21.1081 20.75 20.6757L22 20",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricPoolCover);
export default __webpack_public_path__ + "static/media/electric_pool_cover.2a98a3990968350be7527c8e02df033a.svg";
export { ForwardRef as ReactComponent };